import React, { useState } from 'react';
import { Lock, ArrowRight, Sparkles } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { isValidSecretCode } from '../../services/authService';
import logoShynea from '../../assets/logo-shynea.png';
import './AuthModal.css';

const SetupSecretCodeModal = () => {
  const { completeSecretCodeSetup } = useAuth();
  const [secretCode, setSecretCode] = useState('');
  const [confirmSecretCode, setConfirmSecretCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!isValidSecretCode(secretCode)) {
      setError('Le code secret doit contenir 4 à 6 chiffres');
      return;
    }
    if (secretCode !== confirmSecretCode) {
      setError('Les codes ne correspondent pas');
      return;
    }

    setLoading(true);
    try {
      const result = await completeSecretCodeSetup(secretCode, confirmSecretCode);
      if (!result.success) {
        setError(result.message || "Erreur lors de l'enregistrement");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-modal-overlay setup-secret-overlay">
      <div
        className="auth-modal setup-secret-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="setup-secret-title"
      >
        <div className="auth-modal-panel">
          <div className="auth-panel-head" style={{ textAlign: 'center', paddingRight: 0 }}>
            <div
              className="auth-brand-logo-wrap"
              style={{ margin: '0 auto 18px', width: 64, height: 64 }}
            >
              <img src={logoShynea} alt="" className="auth-brand-logo" style={{ width: 42, height: 42 }} />
            </div>
            <p className="auth-brand-kicker" style={{ color: 'var(--primary-dark)', justifyContent: 'center', width: '100%' }}>
              <Sparkles size={14} />
              Sécurité
            </p>
            <h2 id="setup-secret-title" className="auth-panel-title">
              Créez votre code secret
            </h2>
            <p className="setup-secret-desc">
              Choisissez un code à 4–6 chiffres. Vous l’utiliserez pour vos prochaines connexions.
            </p>
          </div>

          <form className="auth-modal-form" onSubmit={handleSubmit}>
            <div className="auth-field">
              <label htmlFor="setup-code">Code secret</label>
              <div className="auth-input-wrap">
                <Lock size={17} className="auth-input-ico" strokeWidth={2} />
                <input
                  id="setup-code"
                  type="password"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={6}
                  value={secretCode}
                  onChange={(e) => setSecretCode(e.target.value.replace(/\D/g, ''))}
                  placeholder="••••"
                  disabled={loading}
                  required
                />
              </div>
            </div>

            <div className="auth-field">
              <label htmlFor="setup-confirm">Confirmer le code</label>
              <div className="auth-input-wrap">
                <Lock size={17} className="auth-input-ico" strokeWidth={2} />
                <input
                  id="setup-confirm"
                  type="password"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={6}
                  value={confirmSecretCode}
                  onChange={(e) =>
                    setConfirmSecretCode(e.target.value.replace(/\D/g, ''))
                  }
                  placeholder="••••"
                  disabled={loading}
                  required
                />
              </div>
            </div>

            {error && (
              <div className="auth-server-error" role="alert">
                {error}
              </div>
            )}

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              <span>{loading ? 'Enregistrement…' : 'Enregistrer mon code'}</span>
              {!loading && <ArrowRight size={18} strokeWidth={2.25} />}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SetupSecretCodeModal;
